module.exports = __webpack_public_path__ + "rings-thumb.06ff388ccb1a2aba2155d6e765c67f20.png";